import { useMemo } from 'react';

import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';

export interface CompanyCellPropsHook {
  searchWords: string[];
  name: string;
  email: string;
  phone: string;
}

export default function useCompanyCellProps(
  companyName: string,
  companyContactEmail: string,
  companyContactPhone: string,
): CompanyCellPropsHook {
  const [query] = useQuery('companies');

  const searchWords = useSearchWords(query);

  const name = useMemo(() => {
    if (!companyName) return 'No name added';
    if (/^\s*$/.test(companyName)) return 'No name added';
    return companyName;
  }, [companyName]);

  const email = useMemo(() => {
    if (!companyContactEmail) return 'No email added';
    if (/^\s*$/.test(companyContactEmail)) return 'No email added';
    return companyContactEmail;
  }, [companyContactEmail]);

  const phone = useMemo(() => {
    if (!companyContactPhone) return 'No phone added';
    if (/^\s*$/.test(companyContactPhone)) return 'No phone added';
    return companyContactPhone;
  }, [companyContactPhone]);

  return {
    searchWords,
    name,
    email,
    phone,
  };
}
